export default "__VITE_ASSET__DM1$JW3V__"